import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import RegistrationForm from './RegistrationForm'
import { Container, Row, Col, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import moment from 'moment';
import localization from 'moment/locale/de';

moment.locale('de');

class App extends Component {
  constructor(props) {
    super(props);

    this.locations = {
      'Berlin': {
        'addressLine1': 'Prager Straße 5',
        'addressLine2': '10779 Berlin',
        'addressLine3': '',
        'country': 'DE',
        'phone': '030 - 27 97 67 44',
        'email': 'info@doc4drive.de',
      },
      'Hamburg': {
        'addressLine1': 'Krieterstraße 30',
        'addressLine2': '21109 Hamburg',
        'addressLine3': 'im Ärztehaus Wilhelmsburg',
        'country': 'DE',
        'phone': '040 53541335',
        'email': 'hamburg@doc4drive.de',
      },
      'Köln': {
        'addressLine1': 'Leskanpark, Waltherstraße 49-51',
        'addressLine2': '51069 Köln',
        'addressLine3': 'im Ärztehaus Wilhelmsburg',
        'country': 'DE',
        'phone': '0221 - 75 96 06 33',
        'email': 'koeln@doc4drive.de'
      },
      'Düsseldorf': {
        'addressLine1': 'Fürstenwall 146',
        'addressLine2': '40215 Düsseldorf',
        'addressLine3': '',
        'country': 'DE',
        'phone': '0211 - 58 07 99 32',
        'email': 'duesseldorf@doc4drive.de'
      },
      'München': {
        'addressLine1': 'Neuhauser Straße 47',
        'addressLine2': '80331 München',
        'addressLine3': '',
        'country': 'DE',
        'phone': '',
        'email': 'muenchen@betriebsarztservice.de'
      },
      'Stuttgart': {
        'addressLine1': 'Jägerstrasse 40',
        'addressLine2': '70174 Stuttgart',
        'addressLine3': '',
        'country': '',
        'phone': '0711 - 23 19 81 35',
        'email': 'stuttgart@doc4drive.de'
      },
      'Rostock': {
        'addressLine1': 'Goethestraße 17',
        'addressLine2': '18055 Rostock',
        'addressLine3': '',
        'country': 'DE',
        'phone': '',
        'email': 'rostock@doc4drive.de',
      },
      'Frankfurt am Main': {
        'addressLine1': 'Alleestraße 24',
        'addressLine2': '65812 Bad Soden am Taunus',
        'addressLine3': '',
        'country': 'DE',
        'phone': '06196 / 5235186',
        'email': 'frankfurt@betriebsarztservice.de',
      },
    }

    this.state = {
      isOpen: false,
      bookingCompleted: false,
      selectedTimeslot: null,
      selectedAppointmentType: null,
      location: null,
    };

    this.toggle = this.toggle.bind(this);
    this.handleBooking = this.handleBooking.bind(this);
  }

  handleBooking(selectedTimeslot, selectedAppointmentType, location) {
    this.setState({
      bookingCompleted: true,
      selectedTimeslot: selectedTimeslot,
      selectedAppointmentType: selectedAppointmentType,
      location: location
    })
  }

  toggle() {
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    if (this.state.bookingCompleted) {
      return this.renderSuccessPage();
    }

    return this.renderForm();
  }

  renderForm() {
    return (
      <div>
        <header>
          <Container>
            <Row>
            <Col sm={6} className="my-auto"><a href="/"><img src="/img/doc4drive-logo.png" /></a></Col>
              <Col sm={6} className="my-auto text-right d-none d-md-block">Ein Angebot von: <img src="/img/betriebsarzt-logo.png" /></Col>
              { /*<Col sm={2} className="my-auto">Lang switcher</Col>*/ }
            </Row>
          </Container>
        </header>
        <div className="main-wrapper">
          <Container>
            <div className="form-wrapper">
              <div className="form-header">
                Eignungsuntersuchungen nach Fahrerlaubnisverordnung (FeV)
              </div>
              <div className="row no-gutters">
                <Col lg={8}>
                  <RegistrationForm clientId="sriw3dpfvhl7hhxlf563jw0waf9nsc0" practiceId="pqsnx8bnda96b34g" categoryId="51301" onSuccess={this.handleBooking}/>
                </Col>
                <Col className="d-none d-lg-block" lg={4}>
                  <div className="right-column">
                    { /*<div className="text-right">*/ }
                      <img src="/img/taxi-team.png" />
                    { /*</div>*/ }
                    <ul className="usp-list">
                      <li>Schnelle Termine</li>
                      <li>Günstige Preise</li>
                      <li>Zentrale Lage</li>
                    </ul>

                    <div>
                      <div className="contact-us-wrapper">
                        <div className="text-container">
                          { /*<div className="question">Fragen? Rufen Sie uns an</div>
                          <div className="number"><a href="tel:03027976744">030 27976744</a></div> */ }
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </div>

            </div>

            <Row className="footnotes-container">
              <Col lg={8}>
                Mit der abschließenden Buchung vereinbaren Sie verbindlich einen Termin bei Ihrem Arzt, der zu einer Reservierung und ärztlichen Leistungsabrechnung führt. Bitte rufen Sie bei Zwischenfällen oder Absagen direkt Ihren Arzt an.
                <br />
                <br />
                <a href="#" onClick={this.toggle}>* Welche persönlichen Daten werden weitergegeben?</a>
                <Modal isOpen={this.state.isOpen} toggle={this.toggle}>
                  <ModalHeader toggle={this.toggle} />
                  <ModalBody>
                    <div className="personal-data-modal-body">
                        <p>
                          Durch Akzeptieren der Nutzungsbedingungen erklären Sie sich damit einverstanden, dass folgende persönliche Daten (soweit verfügbar) an doc4drive.de weitergegeben werden *:
                        </p>
                        <ul>
                          <li>Vollständiger Name</li>
                          <li>Email-Adresse</li>
                          <li>Telefonnummern</li>
                        </ul>
                        <p>
                          * Daten aus dem Abschnitt "Zusätzliche Daten" werden ebenso an doc4drive.de weitergegeben.
                        </p>
                    </div>
                  </ModalBody>
                </Modal>

              </Col>
              <Col className="text-right">
                 <a href="https://www.doc4drive.de/impressum" target="_blank">Impressum</a>
                {' '}|{' '}
                 <a href="https://www.doc4drive.de/datenschutz" target="_blank">Datenschutz</a>
                 <br />
                 <div>
                  Ein Service von <a href="https://patient.samedi.de/" target="_blank"><img src="/img/samedi-logo.png" height="20" /></a>
                 </div>
              </Col>
            </Row>
          </Container>
        </div>

      </div>
    );
  }

  renderSuccessPage() {
    const locationData = this.locations[this.state.location];

    return (
      <div>
        <header>
          <Container>
            <Row>
            <Col sm={6} className="my-auto"><a href="/"><img src="/img/doc4drive-logo.png" /></a></Col>
              <Col sm={6} className="my-auto text-right d-none d-md-block">Ein Angebot von: <img src="/img/betriebsarzt-logo.png" /></Col>
              { /*<Col sm={2} className="my-auto">Lang switcher</Col>*/ }
            </Row>
          </Container>
        </header>
        <div className="main-wrapper">
          <Container>
            <div className="form-wrapper">
              <div className="form-header">
                <div className="your-appointment">
                  Ihr Termin
                </div>
                <div className="your-appointment-date">
                  {moment(this.state.selectedTimeslot.time).format("dddd, DD. MMMM YYYY")}
                </div>
                <div className="your-appointment">
                  {moment(this.state.selectedTimeslot.time).format("HH:mm [Uhr]")}
                </div>
              </div>
              <div className="row no-gutters">
                <Col lg={12}>
                  <div className="success-content-container">
                    <p>
                    Eignungsuntersuchung nach FeV (Taxi)<br />
                    {this.state.selectedAppointmentType.label}
                    </p>
                    <p>
                      In Kürze erhalten Sie eine E-Mail mit der Terminbestätigung.
                    </p>

                    <p>
                    <a href="https://doc4drive.de">doc4drive.de</a><br />
                    {locationData.addressLine1}<br />
                    {locationData.addressLine2}<br />
                    {locationData.addressLine3}<br />
                    {locationData.country}<br />
                    </p>

                    <p>
                      <a href="https://goo.gl/maps/S8jtDcaq8WS2">In Google Maps öffnen</a>
                    </p>

                    <p>
                    Telefon <a tel={`${locationData.phone}`}>{locationData.phone}</a><br />
                    Mo - Do: 07:00 - 16:00 Fr: 07:00 - 13:00
                    </p>

                    <p>
                    Wir freuen uns auf Sie, Gute Fahrt!
                    </p>
                  </div>
                </Col>
              </div>

            </div>

            <Row className="footnotes-container">
              <Col lg={8}>
                Mit der abschließenden Buchung vereinbaren Sie verbindlich einen Termin bei Ihrem Arzt, der zu einer Reservierung und ärztlichen Leistungsabrechnung führt. Bitte rufen Sie bei Zwischenfällen oder Absagen direkt Ihren Arzt an.
                <br />
                <br />
                <a href="#" onClick={this.toggle}>* Welche persönlichen Daten werden weitergegeben?</a>
                <Modal isOpen={this.state.isOpen} toggle={this.toggle}>
                  <ModalHeader toggle={this.toggle} />
                  <ModalBody>
                    <div className="personal-data-modal-body">
                        <p>
                          Durch Akzeptieren der Nutzungsbedingungen erklären Sie sich damit einverstanden, dass folgende persönliche Daten (soweit verfügbar) an doc4drive.de weitergegeben werden *:
                        </p>
                        <ul>
                          <li>Vollständiger Name</li>
                          <li>Email-Adresse</li>
                          <li>Telefonnummern</li>
                        </ul>
                        <p>
                          * Daten aus dem Abschnitt "Zusätzliche Daten" werden ebenso an doc4drive.de weitergegeben.
                        </p>
                    </div>
                  </ModalBody>
                </Modal>

              </Col>
              <Col className="text-right">
                 <a href="https://www.doc4drive.de/impressum" target="_blank">Impressum</a>
                {' '}|{' '}
                 <a href="https://www.doc4drive.de/datenschutz" target="_blank">Datenschutz</a>
                 <br />
                 <div>
                  Ein Service von <a href="https://patient.samedi.de/" target="_blank"><img src="/img/samedi-logo.png" height="20" /></a>
                 </div>
              </Col>
            </Row>
          </Container>
        </div>

      </div>
    )
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js